import {useSession} from 'next-auth/react';
import {useState, useEffect, useCallback} from 'react';
import AthenaAPI from '../../APIs/AthenaAPI';
import {AgentData, InternalUser} from '@amplify/athena-models';

export const useAgentAdminData = () => {
    const {data: session} = useSession();
    const [agentData, setAgentData] = useState<InternalUser['agentData'] | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const fetchAgentData = useCallback(async () => {
        if (!session?.user?.email) {
            setLoading(false);
            return null;
        }

        try {
            setLoading(true);
            const agent = await AthenaAPI.getInternalUser(session.user.email);

            const data = agent?.agentData || null;
            setAgentData(data);
            setError(null);
            return data;
        } catch (err: any) {
            console.error('Error fetching agent data:', err);
            setError(err);
            setAgentData(null);
            return null;
        } finally {
            setLoading(false);
        }
    }, [session?.user?.email]);

    useEffect(() => {
        fetchAgentData();
    }, [fetchAgentData]);

    return {
        agentData: agentData as AgentData | null,
        loading,
        error,
        refetch: fetchAgentData,
    };
};
